import "bootstrap/dist/css/bootstrap.min.css";
import { useEffect, useState } from "react";
import BModal from "react-bootstrap/Modal";
import * as profileActions from "../../../../../actions/Profile";

const QuestionPrompt = ({ show, onHide, modalData, onSave }) => {
  const [text, setText] = useState("");
  const [textTouched, setTextTouched] = useState(false);
  const [validationErrors, setValidationErrors] = useState([]);

  // Function to clear default value and reset modal state
  const clearDefaultValue = () => {
    setText("");
    setTextTouched(false);
    setValidationErrors([]);
  };

  // Validation functions
  const validateBio = (inputText) => {
    const errors = [];

    // Get text without spaces for validation
    const textWithoutSpaces = inputText.replace(/\s/g, '');

    // Only apply validation rules if there's actual content (not empty or just whitespace)
    const hasContent = inputText.trim().length > 0;

    if (hasContent) {
      // Check minimum length first (priority error)
      if (textWithoutSpaces.length < 10) {
        errors.push("Bio must be at least 10 characters long.");
        return errors; // Return early to show only this error
      }

      // Check maximum length
      if (textWithoutSpaces.length > 200) {
        errors.push("Bio must not exceed 200 characters.");
        return errors; // Return early to show only this error
      }

      // Check for alphabetical words (must contain at least one letter)
      const hasAlphabeticalWords = /[a-zA-Z]/.test(inputText);
      if (!hasAlphabeticalWords) {
        errors.push("Bio must contain at least one alphabetical word.");
      }
    }

    return errors;
  };

  useEffect(() => {
    (async () => {
      if (!modalData?.questionId) {
        clearDefaultValue();
        return;
      }

      const data = await profileActions.getQuestionAnswer(modalData.questionId);

      if (data && data.answer) {
        setText(data.answer);
      } else if (modalData?.answer) {
        setText(modalData.answer);
      } else {
        clearDefaultValue();
      }
    })()
  }, [modalData?.questionId, modalData?.answer, show]);

  async function handleSave() {
    const isEmpty = /^\s*$/.test(text);
    if (isEmpty) {
      setTextTouched(true);
      setValidationErrors(["Please provide some input to save the data."]);
      return;
    }

    // Validate bio with new rules
    const errors = validateBio(text);
    if (errors.length > 0) {
      setTextTouched(true);
      setValidationErrors(errors);
      return;
    }

    setValidationErrors([]);

    const finalanswer = text ? text : "";
    onSave(modalData.questionId, finalanswer);
  }


  return (
    <BModal
      className="customer-modal-without-header-footer"
      centered
      show={show}
      onHide={onHide}
      backdrop="static"
      keyboard={false}
    >
      <BModal.Header>
        <p style={{ fontSize: "large", fontWeight: 600, margin: "0 auto" }}>
          {modalData.heading}
        </p>
      </BModal.Header>

      <div style={{ position: "relative" }}>
        <div>
          <p style={{
            color: "#6C6C6C",
            fontSize: "14px",
            lineHeight: "16px",
          }}>
            Please keep it between 10–200 characters, words only. No contact info like social handles, phone numbers, or emails.
          </p>
        </div>
        <textarea
          name={modalData.heading}
          id={modalData.heading}
          value={text}
          placeholder={text ? "" : modalData.placeholder}
          onChange={(e) => {
            setText(e.target.value);
          }}
          maxLength={200}
          style={{
            height: "300px",
            marginBlock: "1rem",
            borderRadius: "10px",
            border: "2px solid #cbcbcb",
            padding: "1rem",
            width: "100%",
          }}
        />
        <p style={{
          position: "absolute",
          right: "1rem",
          bottom: "2rem",
          color: "#6C6C6C",
          fontSize: "14px",
          lineHeight: "20px",
          fontWeight: "400",
        }}>{text?.replace(/\s/g, '').length}/200</p>
      </div>

      <div>
        {textTouched && validationErrors.length > 0 && (
          <p className="text-danger error-message">{validationErrors[0]}</p>
        )}
      </div>

      <div
        style={{
          marginTop: "2rem",
          display: "flex",
          gap: "1rem",
          justifyContent: "center",
        }}
      >
        <button className='global-cancel-button' onClick={() => { clearDefaultValue(); onHide(); }}>
          Close
        </button>
        <button className='global-save-button' onClick={() => {
          handleSave()
        }}>
          Save
        </button>
      </div>
    </BModal>
  );
};
export default QuestionPrompt;
